import React from 'react';
import { WelcomeParent as WelcomeScreen } from '@features/welcome';

/** Routed screen — wrap with shared layout/chrome here if needed. */
export const WelcomeParent = (props: any) => <WelcomeScreen {...props} />;
